import { render, staticRenderFns } from "./BbeeCalidadPFOVLM.vue?vue&type=template&id=10b2d85c"
import script from "./BbeeCalidadPFOVLM.vue?vue&type=script&lang=js"
export * from "./BbeeCalidadPFOVLM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports